import { Link, NavLink } from "react-router-dom";
import classNames from "../classNames";
import moment from "moment";

const defaultProps = {
  background: "white",
  padding: "2",
};

function ApplicationCard({ className, background, children, object, index }) {
  const classes = classNames(
    className,
    "shadow-sm rounded",
    `bg-${background}`
  );

  const statuses = {
    New: {
      icon: "bi bi-briefcase-fill",
      color: "#D9700B",
      border: "#D18237",
      bg: "#F8D1AB",
      fontSize: `0.9rem`,
    },
    "For Interview": {
      icon: "bi bi-person-fill",
      color: "#E5B62B",
      border: "#E1D417",
      bg: "#FFFDBC",
      fontSize: `0.85rem`,
    },
    Pass: {
      icon: "bi bi-check-circle-fill",
      color: "#6D9E5F",
      border: "#6D9E5F",
      bg: "#BCD7B4",
      fontSize: `0.9rem`,
    },
    Failed: {
      icon: "bi bi-x-circle-fill",
      color: "#B82020",
      border: "#B82020",
      bg: "#FEB6B6",
      fontSize: `0.9rem`,
    },
    "On-boarding": {
      icon: "bi bi-people-fill",
      color: "#006390",
      border: "#3174AD",
      bg: "#96BEDF",
      fontSize: `0.85rem`,
    },
    "For Coordinator": {
      icon: "bi bi-person-fill",
      color: "#795548",
      border: "#795548",
      bg: "#D7CCC8",
      fontSize: `0.85rem`,
    },
    "For Endorsement": {
      icon: "bi bi-hand-thumbs-up-fill",
      color: "#00897B",
      border: "#00897B",
      bg: "#B2DFDB",
      fontSize: `0.7rem`,
    },
    Hired: {
      icon: "bi bi-check-circle-fill",
      color: "#6D9E5F",
      border: "#6D9E5F",
      bg: "#BCD7B4",
      fontSize: `0.9rem`,
    },
    "Not Hired": {
      icon: "bi bi-x-circle-fill",
      color: "#dc3545",
      border: "#dc3545",
      bg: "#f8d7da",
      fontSize: "0.9rem",
    },
  };

  const statusObject = statuses[object?.status] || statuses["New"];

  return (
    <div className="p-3 p-md-4 rounded-4 bg-white d-flex flex-column overflow-hidden mt-4 w-100">
      <div className="d-flex flex-column flex-md-row justify-content-between w-100 gap-2">
        <div className="d-flex flex-column w-100">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
            <h3 className="fs-5 fw-bold text-dark text-truncate pe-2 order-2 order-md-1">
              {object?.positionApplied}
            </h3>
            <div
              className="d-flex align-items-center justify-content-center p-2 rounded-5 order-1 order-md-2 gap-2 w-100 w-md-auto"
              style={{
                border: `2px solid ${statusObject.border}`,
                backgroundColor: statusObject.bg,
                maxWidth: "150px",
              }}
            >
              <i
                className={`${statusObject.icon} fs-5`}
                style={{ color: statusObject.color }}
              ></i>
              <p
                className="fw-bold m-0"
                style={{
                  color: `#303030`,
                  fontSize: `${statusObject.fontSize}`,
                }}
              >
                {object?.status}
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 mt-2">
            <b className="text-muted small">Reference No.</b>
            <span className="text-dark text-truncate small">
              {object?.referenceNumber}
            </span>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between mt-3 gap-2">
            <NavLink
              className="small text-success text-decoration-underline"
              to={`/application-status/form/${object?.interviewCoordinator}/${object?.id}`}
              style={{ color: `#6D9E5F` }}
            >
              View Application Form
            </NavLink>

            <p className="text-muted small m-0">
              {moment(object?.created).format("D MMM YYYY h:mm a")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

ApplicationCard.defaultProps = defaultProps;
export default ApplicationCard;
